// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QNtO","colMin":"styles_colMin__3FSpz"};